import { Domains, KeyValue } from "@ca.vmedia.tv/domains";
import { LangCodes } from "@/common/types/languages";

declare module '#app' {
  interface NuxtApp {
    $domains: Domains;
  }
}
declare module 'vue' {
  interface ComponentCustomProperties {
    $domains: Domains;
  }
}

export default defineNuxtPlugin({
  name: "domains",
  dependsOn: ['platform', 'webos-plugin'],
  setup: async (nuxtApp) => {
    const { $platform, $i18n } = useNuxtApp();
    const platformInfo = await $platform.getInfo();
    const deviceInfo = await $platform.getDeviceInfo();
    
    const locale = $i18n.locale.value === LangCodes.EN ? 'eng' : 'fra';
    const config = useAppConfig();

    const domains = new Domains(
      {
        deviceId: deviceInfo.macAddress,
        macAddress: deviceInfo.macAddress,
        model: deviceInfo.build?.model ?? `${platformInfo.platformType}:${platformInfo.model}`,
      },
      [
        new KeyValue(null, 'box.app_version', config.appVersion),
        new KeyValue(null, 'box.build_number', config.buildCounter),
      ],
      config.applicationName,
      locale,
      null,
      Number(config.siteId),
      config.baseUrl,
      config.npasUrl,
      nuxtApp
    );
  
    nuxtApp.provide('domains', domains);
  }
});